import { Input } from "./ui/input";

const fmt = (v) => (v === "" || v === null || v === undefined || isNaN(Number(v)) ? "" : Number(v).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }));

// Campo de valor em reais com máscara 1.200,58 — onChange recebe { target: { value: "1200.58" } }
export function MoneyInput({ value, onChange, className = "", ...rest }) {
  const change = (e) => {
    const digits = e.target.value.replace(/\D/g, "").replace(/^0+(?=\d)/, "");
    onChange({ target: { value: digits ? (Number(digits) / 100).toFixed(2) : "" } });
  };
  return (
    <div className={`relative ${className}`}>
      <span className="pointer-events-none absolute inset-y-0 left-3 flex items-center text-sm text-slate-500">R$</span>
      <Input {...rest} type="text" inputMode="numeric" className="pl-9" value={fmt(value)} onChange={change} />
    </div>);
}
